import { render, staticRenderFns } from "./Games-Single.vue?vue&type=template&id=39714004&scoped=true"
import script from "./Games-Single.js?vue&type=script&lang=js&external"
export * from "./Games-Single.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39714004",
  null
  
)

export default component.exports